import React from 'react';
import cx from 'classnames';
import cs from './index.module.scss';

const InvitePullDownIcon: React.FC<any> = ({ className, ...restProps }) => (
  <span className={cx(cs.container, className)} {...restProps}>
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.69582 9.78222L12.3418 6.01048C12.5571 5.78817 12.9055 5.78817 13.1201 6.01048C13.335 6.23277 13.335 6.59344 13.1201 6.81573L9.08485 10.9898C8.86993 11.2117 8.52137 11.2117 8.30713 10.9898L4.27208 6.81573C4.16462 6.70424 4.1109 6.55852 4.1109 6.41277C4.1109 6.26702 4.16463 6.12129 4.27243 6.01048C4.48735 5.78817 4.83523 5.78817 5.05015 6.01048L8.69582 9.78222Z"
        fill="#8A8A8A"
      />
    </svg>
  </span>
);

export default InvitePullDownIcon;
